import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { ProcessStep } from '../common/enums/enums';
import { toLocalDateTime, now } from '../helpers/date';

const formatDurationTime = ({ values: duration }) =>
  Object.entries(duration)
    ?.map(([key, val]) =>
      val ? Math.floor(val) + key.charAt(0).toUpperCase() : ''
    )
    ?.join(' ') || '';

const getStepTimestamp = (step, steps) => {
  return toLocalDateTime(steps.find(x => x.step === step)?.createdAt);
};

const getDurationTime = (currentStep, steps) => {
  const { ARRIVED, IN_PROCESS, DONE } = ProcessStep;
  let from = null;

  if (currentStep === IN_PROCESS || currentStep === ARRIVED) {
    from = now();
  }

  if (currentStep === DONE) {
    from = getStepTimestamp(DONE, [...steps].reverse());
  }

  return from
    ? formatDurationTime(
        from.diff(getStepTimestamp(ARRIVED, steps), [
          'days',
          'hours',
          'minutes',
        ])
      )
    : null;
};

const stepsAfterLastArrivedStatus = steps => {
  if (!steps?.length) return null;
  const lastArrivedIndex = steps.reduce((acc, s, i) => {
    if (s.step === ProcessStep.ARRIVED) {
      acc = i;
    }
    return acc;
  }, -1);

  return lastArrivedIndex >= 0 ? steps.slice(lastArrivedIndex) : steps;
};

const Timer = ({ currentStep, steps }) => {
  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-end"
      alignItems="center"
    >
      <Grid item>
        <Box>
          <Grid container direction="row">
            <Grid item>
              <Typography variant="h6">
                {getDurationTime(
                  currentStep,
                  stepsAfterLastArrivedStatus(steps)
                )}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Timer;
